//POVERHNOST-TV OPERATOR

import ru_RU from '../../ru_RU';

const extend = {
  tv: 'ТВ'
};

const ru_POVTV = {...ru_RU, ...extend};

export default ru_POVTV;



// WEBPACK FOOTER //
// ./src/locales/dics/ext/povtv/ru_POVTV.js